import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './reportgroup-model';  //editable..
import OwnerPicklist from '../owner/owner-picklist.component';
import ReportChecklist from '../report/report-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class ReportgroupCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadReport = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'report': data || [], 'reportCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} 
                model={Model} datarow={this.state.datarow} onError={this.onError}>               
          
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                <InputPicklist name='report' label='Report List' value={this.state.datarow.report} caption={this.state.datarow.reportCaption} disableAutoClose clearValue={this.onLoadReport} error={this.state.errors?.report} onChange={this.onChange}>
                    <ReportChecklist history={this.props.history} currentId={this.state.datarow.report} onLoad={this.onLoadReport} disableBackButton/>
                </InputPicklist>     
            </BaseCreate>
        );
    }     
     
}